export default "<p>select-control works!</p>\n"